import { Link, useSearchParams } from "react-router-dom";
import Button from "./Button.tsx";
import Range from "./Range.tsx";
import Card from "./Card.tsx";

export default function FruitCard({
	title,
	description,
	bg,
	fruit,
	setValue,
	value,
	back,
	next,
}: {
	title: string;
	description: string;
	bg: string;
	fruit: string;
	setValue: (value: number) => void;
	value: number;
	back?: string;
	next: string;
}) {
	// Get redirect url
	const [searchParams, _setSearchParams] = useSearchParams();

	const redirect = searchParams.get("redirect");

	return (
		<Card bg={bg} dim={true}>
			<div className="min-h-screen p-4 text-white flex flex-col justify-between gap-4">
				<div>
					<h1 className="text-5xl font-bold italic">{title}</h1>
				</div>
				<div className="flex flex-col justify-between gap-4">
					<div className="flex justify-around items-center portrait:flex-col">
						<img src={fruit} className="w-87.5 h-auto" />
						<p className="max-w-140 italic text-[20px]/5.5">{description}</p>
					</div>
					<div className="flex flex-col gap-4 self-center max-w-160 w-full">
						<p className="text-6xl font-semibold italic self-end">{value}</p>
						<Range min={0} max={85} step={1} value={value} update={setValue} />
					</div>
				</div>
				<div className="grid grid-cols-2">
					{back && (
						<Link
							to={back + (redirect ? `?redirect=${redirect}` : "")}
							className="col-1 justify-self-start"
							viewTransition
						>
							<Button>Back</Button>
						</Link>
					)}
					<Link
						to={next + (redirect ? `?redirect=${redirect}` : "")}
						className="col-2 justify-self-end"
						viewTransition
					>
						<Button>Next</Button>
					</Link>
				</div>
			</div>
		</Card>
	);
}
